const auth = async ({next, store}) => store.getters['auth/currentUser'].userId ? next() : next({name: 'auth'});

export default auth;